<template>
    <form-wrapper>
        <div class="email-collector">
            <form-repeater
                :repeats="repeats"
                :add="$t(addLinkLabel)"
                :hint="''"
                :remove="''"
                :isDisabled="false"
                @add="addRepeat()"
                @remove="removeRepeat($event)"
            >
                <template #default="{ data, index }">
                    <form-row class="email-collector--name-row">
                        <form-cell width="half">
                            <text-field
                                :label="$t('elements.network.email_collector.first_name')"
                                :placeholder="$t('elements.network.email_collector.first_name')"
                                :isRequired="false"
                                :formData="data"
                                :valuePath="valuePathField(index, 'firstName')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></text-field>
                        </form-cell>

                        <form-cell width="half">
                            <text-field
                                :label="$t('elements.network.email_collector.last_name')"
                                :placeholder="$t('elements.network.email_collector.last_name')"
                                :isRequired="false"
                                :formData="data"
                                :valuePath="valuePathField(index, 'lastName')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                    <form-row>
                        <form-cell>
                            <phone-field
                                v-if="displayPhoneField"
                                :label="label + ' ' + (index + 1) + ' ' + $t(inviteByLabel)"
                                :placeholder="$t('common.phone_number.placeholder')"
                                :isRequired="false"
                                :formData="data"
                                :error="data.error"
                                :valuePath="valuePathField(index, 'email')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></phone-field>
                            <text-field
                                v-if="displayEmailField"
                                :label="label + ' ' + (index + 1) + ' ' + $t(inviteByLabel)"
                                :placeholder="$t(inviteByPlaceholder)"
                                :isRequired="false"
                                :formData="data"
                                :title="$t(inviteByFieldTitle)"
                                :error="data.error"
                                type="email"
                                :valuePath="valuePathField(index, 'email')"
                                :formRepeater="true"
                                @change="changeRepeat(index, $event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                </template>
            </form-repeater>
            <form-row>
                <form-cell>
                    <common-button
                        :label="buttonLabel"
                        type="primary"
                        :isSubmittable="true"
                        :isDisabled="isDisabled()"
                        @click="collect"
                    ></common-button>
                </form-cell>
            </form-row>
        </div>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import FormRepeaterMixin from 'mixins/FormRepeaterMixin'
    import FormChangeableMixin from 'mixins/FormChangeableMixin'
    import InviteByEnum from '@/enums/InviteByEnum'

    export default {
        mixins: [FormMixin, FormChangeableMixin, FormRepeaterMixin],

        props: {
            label: { type: String, required: true },
            placeholder: { type: String, required: true },
            buttonLabel: { type: String, required: true },
            initialNumOfFields: { type: Number, default: 3 },
            inviteBy: { type: String, required: false, default: InviteByEnum.INVITE_BY_EMAIL },
        },
        data() {
            return {
                phoneCountryCode: '1',
            }
        },
        computed: {
            inviteByLabel() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
                    ? 'elements.network.email_collector.email'
                    : 'elements.network.email_collector.phone'
            },

            inviteByFieldTitle() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
                    ? 'elements.network.email_collector.input_field_title'
                    : 'elements.network.email_collector.input_field_phone_title'
            },

            inviteByPlaceholder() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
                    ? this.placeholder
                    : 'elements.network.email_collector.phone_placeholder'
            },
            addLinkLabel() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
                    ? 'elements.network.email_collector.add_email_link'
                    : 'elements.network.email_collector.add_phone_link'
            },
            displayPhoneField() {
                return this.inviteBy === InviteByEnum.INVITE_BY_PHONE
            },
            displayEmailField() {
                return this.inviteBy === InviteByEnum.INVITE_BY_EMAIL
            },
        },

        methods: {
            collect() {
                let regex = new RegExp(
                    "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
                )
                let errorMessage = this.$t('elements.network.email_collector.invalid_email_address')
                if (this.inviteBy === InviteByEnum.INVITE_BY_PHONE) {
                    //eslint-disable-next-line
                    regex = new RegExp('^[0-9]{10}$')
                    errorMessage = this.$t('elements.network.email_collector.invalid_phone_number')
                }

                if (this.validate(regex, errorMessage)) {
                    const invites = this.formData.emailFields
                        .filter((field) => field.email)
                        .map((invite) => {
                            if (this.inviteBy === InviteByEnum.INVITE_BY_EMAIL) {
                                invite.inviteBy = InviteByEnum.INVITE_BY_EMAIL
                            } else {
                                invite.phone = this.phoneCountryCode + invite.email
                                invite.inviteBy = InviteByEnum.INVITE_BY_PHONE
                                delete invite.email
                            }
                            return invite
                        })

                    this.$emit('emails-collected', invites)
                }
            },
            validate(regex, errorMessage) {
                let allValid = true
                let hasEntries = false

                this.formData.emailFields.forEach((field) => (field.error = ''))

                for (let i = 0; i < this.formData.emailFields.length; ++i) {
                    let field = this.formData.emailFields[i]
                    if (field.email) {
                        hasEntries = true
                        if (!regex.test(field.email)) {
                            field.error = errorMessage
                            allValid = false
                        }
                    }
                }
                return hasEntries && allValid
            },
            createRepeat() {
                return {
                    email: '',
                    error: '',
                }
            },
            isDisabled() {
                return !this.formData.emailFields.some((field) => field.email.length > 0)
            },
        },
    }
</script>

<style scoped>
    .email-collector {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .email-collector .email-collector--name-row {
        margin-bottom: 10px;
    }
    .email-collector > .form-repeater {
        height: 380px;
        overflow-y: auto;
        padding-left: 50px;
        padding-right: 50px;
    }

    .email-collector .add-email-link {
        font-weight: 500;
        color: #13b3e3;
        cursor: pointer;
    }
    .email-collector >>> .form-repeater .form-repeater__group:not(:first-child) {
        border-top: none;
        margin-top: 0px;
    }
    .email-collector >>> .form-repeater .form-repeater__group .form-row:not(:first-child) {
        margin-top: 0px;
    }
</style>
